<template>
  <div class="layergroup">
    <div class="layerheader">
      <icon size="18">layers</icon>
      <div class="layergroup-meta">
        <div class="title">{{ layerType }} Layers</div>
        <div class="description">Layers related to {{ layerType }}</div>
      </div>
    </div>
    <Layer
      v-for="layer in layers"
      :key="layer.id"
      :isActive="layer.isActive"
      :layer="layer"
    />
  </div>
</template>

<script>
import Layer from "@/components/supply_demand_gap/views/Layer";

export default {
  components: {
    Layer,
  },
  props: {
    layerType: String,
    layers: Array,
  },
};
</script>

<style lang="scss" scoped>
.layergroup {
  background: var(--color-secondary);
  border-radius: 5px;
  margin-bottom: 10px;

  .layerheader {
    padding: 10px;
    display: flex;
    align-items: center;

    i {
      margin-right: 15px;
    }

    .description {
      font-size: 0.8em;
      line-height: 1em;
      opacity: 0.7;
    }
  }
}
</style>
